/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GoogleSignupConfig
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Whether to show the Google sign-up button, and with which client id.
 *
 * Public and carries nothing secret. Both answers come from the same flag the
 * other two routes enforce, so the UI cannot offer what the server refuses.
 * @summary Google Signup Config
 */
export const googleSignupConfig = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<GoogleSignupConfig>(
      {url: `/auth/google-signup/config`, method: 'GET', signal
    },
      options);
    }




export const getGoogleSignupConfigQueryKey = () => {
    return [
    `/auth/google-signup/config`
    ] as const;
    }


export const getGoogleSignupConfigQueryOptions = <TData = Awaited<ReturnType<typeof googleSignupConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof googleSignupConfig>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGoogleSignupConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof googleSignupConfig>>> = ({ signal }) => googleSignupConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof googleSignupConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GoogleSignupConfigQueryResult = NonNullable<Awaited<ReturnType<typeof googleSignupConfig>>>
export type GoogleSignupConfigQueryError = unknown


/**
 * @summary Google Signup Config
 */

export function useGoogleSignupConfig<TData = Awaited<ReturnType<typeof googleSignupConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof googleSignupConfig>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGoogleSignupConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






